import Vue from "vue";
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#202b59",
        secondary: "#31bb97",
        black: "#343434",
        textcolor: "#343434",
      },
    },
  },
});
